import type { Campaign, CampaignStatus } from '@/domain/campaign.types'
import type { CampaignLifecyclePort } from '@/domain/campaign-ports'
import { campaignService } from '@/services/campaign.service'
import { mapCampaignHttpError } from './campaign-http-error'

// HTTP-backed CampaignLifecyclePort. The preserved in-memory
// campaign-lifecycle-adapter.ts is untouched; this is a new, independent module.

export const campaignLifecycleHttpAdapter: CampaignLifecyclePort = {
	async getAvailableActions(campaignId: string): Promise<readonly CampaignStatus[]> {
		try {
			// Returns the backend's supplied actions verbatim — no client-side status-map derivation.
			return await campaignService.getAvailableActions(campaignId)
		} catch (error) {
			throw mapCampaignHttpError(error)
		}
	},
	async transition(campaignId: string, to: CampaignStatus): Promise<Campaign> {
		try {
			return await campaignService.transitionCampaign(campaignId, to)
		} catch (error) {
			// A 422 from this endpoint is an invalid-transition, never a generic validation failure.
			throw mapCampaignHttpError(error, { transitionEndpoint: true })
		}
	},
}
